/*:: type SDKOptions = 'ios' | 'android' | 'javascript' | 'server';*/

/*:: type PixelScopes = 'auth.identified.signed'
  | 'auth.identified.unsigned'
  | 'auth.anonymous.signed'
  | 'auth.anonymous.unsigned'
  | 'event.signed'
  | 'event.unsigned'*/

/* eslint arrow-body-style: 0 */
class Integration {
  /*:: static parse: (Object) => Integration; */

  /*:: static serialize: (Integration) => Object; */
  constructor({
    /*: {
        id: ?string,
        name: string,
        sdk: SDKOptions,
        writeKey: ?string,
        corsDomains: ?Array<string>,
        scopes: ?Array<PixelScopes>,
        lifespan: ?number
      }*/

    id,
    name,
    sdk = 'ios',
    writeKey,
    corsDomains,
    scopes,
    lifespan
  }) {
    this.id = id;
    this.name = name;
    this.sdk = sdk;
    this.writeKey = writeKey;
    this.corsDomains = corsDomains;
    this.scopes = scopes;
    this.lifespan = lifespan;
  }

}

Integration.parse = (json
/*: Object*/
) =>
/*: Integration*/
{
  return new Integration({
    id: json.id,
    name: json.name,
    sdk: json.target,
    writeKey: json.writeKey,
    corsDomains: json.corsOrigins,
    scopes: json.scope,
    lifespan: json.lifespan
  });
};

Integration.serialize = (data
/*: Integration*/
) =>
/*: Object*/
{
  return {
    name: data.name,
    target: data.sdk,
    corsOrigins: data.corsDomains,
    scope: data.scopes,
    lifespan: data.lifespan
  };
};

module.exports = Integration;